import React from "react";

const ChevronDownIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="svg-regular" viewBox="0 0 24 24" fill="none">
            <mask id="mask0_250_13646" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_250_13646)">
                <path d="M12 15.3751L6 9.3751L7.4 7.9751L12 12.5751L16.6 7.9751L18 9.3751L12 15.3751Z" fill="current" />
            </g>
        </svg>
    );
};

export default ChevronDownIcon;
